import { useCallback, useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { authNameE } from '../../../utils/userFuncs';
import { teleVisitAPI } from '../../../apis';
import {
  BOOKING_DETAILS,
  TELEVISIT_BOOKING_SOURCE,
  TELEVISIT_CANCEL_TYPE,
  TELEVISIT_REGEX,
  TELEVISIT_STATUS,
  TELEVISIT_DELAY_TYPE,
} from '../../../comm/constant';
import { i18n } from '../../../language';
import { alertMsg } from '../../../apis/commlogic';

const {
  UNAVAILABLE,
  AVAILABLE,
  SCHEDULED_BOOKING,
  CANCELED_BOOKING,
  VERIFYING_BOOKING,
  INPROGRESS_BOOKING,
  URGENT_BOOK,
} = BOOKING_DETAILS;

const initType = (status) => {
  switch (status) {
    case TELEVISIT_STATUS.UNAVAILABLE:
      return UNAVAILABLE;
    case TELEVISIT_STATUS.AVAILABLE:
      return AVAILABLE;
    case TELEVISIT_STATUS.REJECTED:
    case TELEVISIT_STATUS.RESERVED:
      return VERIFYING_BOOKING;
    case TELEVISIT_STATUS.CONFIRMED:
      return SCHEDULED_BOOKING;
    case TELEVISIT_STATUS.CANCEL:
      return CANCELED_BOOKING;
    case TELEVISIT_STATUS.INPROGRESS:
    case TELEVISIT_STATUS.COMPLETED:
    case TELEVISIT_STATUS.COMPLETED_MANUALLY:
    case TELEVISIT_STATUS.ROBOT_START_PROCESSING_BOOKING:
      return INPROGRESS_BOOKING;
    case TELEVISIT_STATUS.URGENT_BOOK:
      return URGENT_BOOK;
    default:
      return AVAILABLE;
  }
};

const initStatus = (timeslotBookingStatusEnum) => {
  switch (timeslotBookingStatusEnum) {
    case TELEVISIT_STATUS.CONFIRMED:
      return i18n.t('TELEVISIT_CONFIRMED_SCHEDULED');
    case TELEVISIT_STATUS.INPROGRESS:
      return i18n.t('TELEVISIT_VISIT_IN_PROGRESS');
    case TELEVISIT_STATUS.COMPLETED:
      return i18n.t('TELEVISIT_VISIT_COMPLETED');
    case TELEVISIT_STATUS.ROBOT_START_PROCESSING_BOOKING:
      return i18n.t('TELEVISIT_ROBOT_STARTS_PROCESS_THE_BOOKING');
    case TELEVISIT_STATUS.AVAILABLE:
      return i18n.t('TELEVISIT_AVAILABLE');
    case TELEVISIT_STATUS.RESERVED:
      return i18n.t('TELEVISIT_VERIFYING');
    case TELEVISIT_STATUS.UNAVAILABLE:
      return i18n.t('TELEVISIT_UNAVAILABLE');
    case TELEVISIT_STATUS.CANCEL:
      return i18n.t('TELEVISIT_CANCELLED');
    case TELEVISIT_STATUS.COMPLETED_MANUALLY:
      return i18n.t('TELEVISIT_VISIT_COMPLETED_MANUALLY');
    case TELEVISIT_STATUS.REJECTED:
      return i18n.t('TELEVISIT_VISIT_REJECTED');
    case TELEVISIT_STATUS.URGENT_BOOK:
      return i18n.t('TELEVISIT_AVAILABLE');
    default:
      break;
  }
};

const getStatusText = (item) => {
  let status = Number(item.dataValue);
  let statusText = '';
  switch (status) {
    case TELEVISIT_STATUS.CONFIRMED:
      statusText = i18n.t('TELEVISIT_STATUS_CONFIRMED_SCHEDULED');
      break;
    case TELEVISIT_STATUS.INPROGRESS:
      statusText = i18n.t('TELEVISIT_STATUS_VISIT_IN_PROGRESS');
      break;
    case TELEVISIT_STATUS.COMPLETED:
      statusText = i18n.t('TELEVISIT_STATUS_VISIT_COMPLETED');
      break;
    case TELEVISIT_STATUS.ROBOT_START_PROCESSING_BOOKING:
      statusText = i18n.t('TELEVISIT_STATUS_ROBOT_STARTS_PROCESS_THE_BOOKING');
      break;
    case TELEVISIT_STATUS.RESERVED:
      statusText = i18n.t('TELEVISIT_STATUS_VERIFYING');
      break;
    case TELEVISIT_STATUS.CANCEL:
      statusText = i18n.t('TELEVISIT_CANCELLED');
      break;
    case TELEVISIT_STATUS.COMPLETED_MANUALLY:
      statusText = i18n.t('TELEVISIT_STATUS_VISIT_COMPLETED_MANUALLY');
      break;
    case TELEVISIT_STATUS.REJECTED:
      statusText = i18n.t('TELEVISIT_STATUS_VISIT_REJECTED');
      break;
    default:
      break;
  }
  return statusText;
};

export default function useTimeslotDialogStatus(props) {
  const { info, handleClose } = props || {};
  const [data, setData] = useState({
    bookingId: '',
    applicationTime: '',
    robotInUse: '',
    location: '',
    patientName: '',
    patientId: '',
    date: '',
    time: '',
    meetingId: '',
    meetingPw: '',
    visitorFullName: '',
    relationship: '',
    contactPhoneNo: '',
    patient: '',
    zoomLink: '',
    langCode: 'zh_HK',
    cancelReasonType: '',
    otherCancelReasonMsg: '',
    rejectReasonType: '',
    durationTime: '',
    bufferTime: '',
    endDate: '',
    hocFlag: 0,
    mainTimeslotBookingId: '',
    startTime: '',
    endTime: '',
    serviceHourSettingIds: [],
  });
  const [list, setList] = useState([]);
  const [serviceHoursList, setServiceHoursList] = useState([]);
  const [serviceDay, setServiceDay] = useState(6);
  const [patient, setPatient] = useState([]);
  const [relationship, setRelationship] = useState([]);
  const [cancelType, setCancelType] = useState([]);

  const [openCtrl, setOpenCtrl] = useState({
    timeslot: true,
    resume: false,
    update: false,
    cancel: false,
    unavailable: false,
    delaySMS: false,
    manualMeeting: false,
    notificationList: false,
    ServiceSupportUpdateBookingStatus: false,
  });
  const [infoErrorMsg, setInfoErrorMsg] = useState({
    patient: '',
    visitorFullName: '',
    relationship: '',
    contactPhoneNo: '',
    startTime: '',
  });
  const [isOutDate, setIsOutDate] = useState(false);
  const [detail, setDetail] = useState({});
  const [cancelInfo, setCancelInfo] = useState({
    cancelReasonType: TELEVISIT_CANCEL_TYPE.DISCHARGED,
    otherCancelReasonMsg: '',
  });
  const language = useSelector((state) => state.settings.language);
  const [smsType, setSmsType] = useState([]);
  const [updateFlag, setUpdateFlag] = useState(false);
  const [currentlyEffective, setCurrentlyEffective] = useState('');
  const [type, setType] = useState(initType(info.timeslotBookingStatusEnum));

  const [hocSupport, setHocSupport] = useState([]);
  const [delayInfo, setDelayInfo] = useState({
    delayTime: 5,
    delayReasonType: TELEVISIT_DELAY_TYPE.OTHER,
    otherDelayReasonMsg: '',
    errorMessage: '',
  });
  const [delayReason, setDelayReason] = useState([]);
  const [serviceHourTimeslot, setServiceHourTimeslot] = useState([]);
  const [durationTime, setDurationTime] = useState([]);
  const [bufferTime, setBufferTime] = useState([]);
  const [timeslotBookingStatus, setTimeslotBookingStatus] = useState([]);
  const [serviceSupportUpdateBookingStatusInfo, setServiceSupportUpdateBookingStatusInfo] = useState({
    bookingId: 0,
    status: String(TELEVISIT_STATUS.COMPLETED),
    cancelReasonType: TELEVISIT_CANCEL_TYPE.OTHER,
    otherCancelReasonMsg: '',
    lang: language,
  });

  const roleMap = useSelector((state) => state.roleMap);

  useEffect(() => {
    setType(initType(info.timeslotBookingStatusEnum));
  }, [info.timeslotBookingStatusEnum]);
  const getDetail = useCallback(async () => {
    try {
      if (type === AVAILABLE || type === UNAVAILABLE) {
        setData((oldData) => ({
          ...oldData,
          robotInUse: info.robotName,
          date: info.day,
          time: info.hocFlag === 1 ? '' : `${info.startTime} - ${info.endTime}`,
          status: initStatus(info.timeslotBookingStatusEnum),
          hocFlag: info.hocFlag,
        }));

        return;
      }

      if (type === URGENT_BOOK) {
        setData((oldData) => ({
          ...oldData,
          robotInUse: info.robotName,
          date: info.day,
          startTime: '',
          endTime: '',
          status: initStatus(info.timeslotBookingStatusEnum),
          durationTime: '',
          bufferTime: '',
          endDate: info.day,
          hocFlag: 1,
        }));

        return;
      }
      const { result } = await teleVisitAPI.getTimeslotDetail({ bookId: info.bookId });
      const _patientId = result.patientCaseNumber ? `${result.patientCaseNumber}, ` : '';

      setType(initType(result.timeslotBookingStatusEnum));
      setDetail(result);

      setData((oldData) => ({
        ...oldData,
        bookingId: result.bookId,
        applicationTime: result.applicationTime,
        robotInUse: result.robotName ?? '-',
        status: initStatus(result.timeslotBookingStatusEnum),
        location: [result.hospitalCode, result.wardCode, result.bedNo].filter((item) => item).join(', '),
        patientName: [result.patientNameEn, result.patientNameCh].filter((item) => item).join(', '),
        patientId: `${_patientId} ${[result.sex, result.age].filter((item) => item).join('/')}`,
        gender: result.sex,
        date: result.timeslotDate,
        time: `${result.startTime} - ${result.endTime}`,
        meetingId: result.zoomMeetingId,
        zoomLink: result.zoomLink,
        meetingPw: result.zoomPwd,
        visitorFullName: result.visitorFullName,
        relationship: result.relationship,
        contactPhoneNo: result.contactPhoneNo,
        langCode: result.langCode ?? 'zh_HK',
        cancelReasonType: result.cancelReasonType,
        otherCancelReasonMsg: result.otherCancelReasonMsg,
        timeslotBookingStatusEnum: result.timeslotBookingStatusEnum,
        rejectReasonType: result.rejectReasonType,
        endDate: result.adHocEndDate,
        startTime: result.hocFlag === 1 ? result.startTime : '',
        endTime: result.adHocEndTime,
        durationTime: result.durationTime,
        bufferTime: result.bufferTime,
        hocFlag: result.hocFlag,
        mainTimeslotBookingId: result.mainTimeslotBookingId,
        serviceHourSettingIds:
          result.hocFlag === 1 ? [result.serviceHoursSettingId, result.subBookingServiceHoursSettingId] : [],
      }));
      setCurrentlyEffective(result.langCode);

      setIsOutDate(result.outDateStatus);
    } catch (error) {
      console.log(error);
    }
  }, [info, type]);

  useEffect(() => {
    (async () => {
      await getDetail();
    })();
  }, [getDetail]);

  const verify = useCallback((key, allData) => {
    if (key === 'startTime' || key === 'bufferTime') {
      return true;
    }

    let value = allData[key];
    if (key === 'visitorFullName') {
      value = value.trim();
    }
    if (value) {
      if (key === 'contactPhoneNo') {
        if (TELEVISIT_REGEX.PHONE.test(allData[key])) {
          setInfoErrorMsg((oldData) => ({ ...oldData, [key]: '' }));
          return true;
        } else {
          setInfoErrorMsg((oldData) => ({ ...oldData, [key]: i18n.t('TELEVISIT_PHONE_ERROR_MSG') }));
          return false;
        }
      }
      setInfoErrorMsg((oldData) => ({ ...oldData, [key]: '' }));
      return true;
    } else {
      setInfoErrorMsg((oldData) => {
        switch (key) {
          case 'patient':
            return { ...oldData, [key]: i18n.t('TELEVISIT_ERROR_PATIENT') };
          case 'visitorFullName':
            return { ...oldData, [key]: i18n.t('TELEVISIT_ERROR_VISITOR_FULL_NAME') };
          case 'relationship':
            return { ...oldData, [key]: i18n.t('TELEVISIT_ERROR_RELATIONSHIP') };
          case 'contactPhoneNo':
            return { ...oldData, [key]: i18n.t('TELEVISIT_ERROR_CONTACT_PHONE') };
          default:
            return oldData;
        }
      });
      return false;
    }
  }, []);

  const moduleDisplay = useMemo(() => {
    switch (type) {
      case UNAVAILABLE:
      case AVAILABLE:
        return {
          selectPatient: true,
          baseDateTime: true,
        };

      case SCHEDULED_BOOKING:
      case CANCELED_BOOKING:
      case INPROGRESS_BOOKING:
        return {
          basicInfo: true,
          televisitLink: true,
          baseDateTime: detail.hocFlag !== 1,
          urgentTimeBook: detail.hocFlag === 1,
          durationAndBufferTime: detail.hocFlag === 1,
        };
      case VERIFYING_BOOKING:
        return {
          basicInfo: true,
          baseDateTime: true,
          urgentTimeBook: false,
        };
      case URGENT_BOOK:
        return {
          selectPatient: true,
          baseDateTime: false,
          urgentTimeBook: true,
          durationAndBufferTime: true,
        };
      default:
        return {};
    }
  }, [type, detail]);

  const dialogProps = useMemo(() => {
    switch (type) {
      case UNAVAILABLE:
        return {
          title: i18n.t('TELEVISIT_UNAVAILABLE_TIMESLOT'),
          cancel: i18n.t('TELEVISIT_POPUP_CHANGE_TO_AVAILABLE'),
          confirm: i18n.t('TELEVISIT_POPUP_RESERVE'),
          confirmStyle: { backgroundColor: '#4c93ff' },
          cancelStyle: { border: 'unset', backgroundColor: '#28d2ab', color: '#fff' },
        };
      case AVAILABLE:
        return {
          title: i18n.t('TELEVISIT_POPUP_AVAILABLE_TIMESLOT'),
          cancel: i18n.t('TELEVISIT_POPUP_CHANGE_TO_UNAVAILABLE'),
          confirm: i18n.t('TELEVISIT_POPUP_RESERVE'),
          confirmStyle: { backgroundColor: '#4c93ff' },
          cancelStyle: { border: 'unset', backgroundColor: '#ff655c', color: '#fff' },
        };
      case URGENT_BOOK:
        return {
          title: i18n.t('TELEVISIT_POPUP_ADHOC_TIMESLOT'),
          cancel: i18n.t('TELEVISIT_POPUP_CHANGE_TO_UNAVAILABLE'),
          confirm: i18n.t('TELEVISIT_POPUP_RESERVE'),
          confirmStyle: { backgroundColor: '#4c93ff' },
          cancelStyle: { border: 'unset', backgroundColor: '#ff655c', color: '#fff', display: 'none' },
        };

      case SCHEDULED_BOOKING:
      case CANCELED_BOOKING:
      case VERIFYING_BOOKING:
      case INPROGRESS_BOOKING:
        return {
          title:
            detail.hocFlag === 0
              ? i18n.t('TELEVISIT_POPUP_BOOKING_DETAILS')
              : i18n.t('TELEVISIT_POPUP_ADHOC_BOOKING_DETAILS'),
          cancel: i18n.t('TELEVISIT_POPUP_CANCEL_BOOKING'),
          confirm: i18n.t('TELEVISIT_POPUP_UPDATE'),
          confirmStyle: { backgroundColor: '#28d2ab' },
          cancelStyle: { border: 'unset', backgroundColor: '#ff655c', color: '#fff' },
        };

      default:
        return {};
    }
  }, [type, i18n, detail.hocFlag]);

  const visitField = useMemo(() => {
    if (isOutDate || type === CANCELED_BOOKING) {
      return {
        date: {
          disabled: true,
        },
        time: {
          disabled: true,
        },
        contactPhoneNo: {
          disabled: true,
        },
        zoom: {
          disabled: true,
        },
        cancel: {
          disabled: true,
        },
        confirm: {
          disabled: true,
        },
        visitorFullName: {
          disabled: true,
        },
        relationship: {
          disabled: true,
        },
        durationTime: {
          disabled: true,
        },
        hocStartDate: {
          disabled: true,
        },
        hocStartTime: {
          disabled: true,
        },
        hocEndDate: {
          disabled: true,
        },
        hocEndTime: {
          disabled: true,
        },
      };
    }

    switch (type) {
      case UNAVAILABLE:
        return {
          date: {
            disabled: true,
          },
          time: {
            disabled: true,
          },
          patient: {
            required: true,
          },
          visitorFullName: {
            required: true,
          },
          relationship: {
            required: true,
          },
          contactPhoneNo: {
            required: true,
          },
          hocStartDate: {
            disabled: true,
          },
          hocStartTime: {
            disabled: true,
          },
          hocEndDate: {
            disabled: true,
          },
          hocEndTime: {
            disabled: true,
          },
        };
      case AVAILABLE:
        return {
          patient: {
            required: true,
          },
          visitorFullName: {
            required: true,
          },
          relationship: {
            required: true,
          },
          contactPhoneNo: {
            required: true,
          },
          hocStartDate: {
            disabled: true,
          },
          hocStartTime: {
            disabled: true,
          },
          hocEndDate: {
            disabled: true,
          },
          hocEndTime: {
            disabled: true,
          },
        };
      case URGENT_BOOK:
        return {
          date: {
            disabled: true,
          },
          hocStartTime: {
            required: true,
          },
          patient: {
            required: true,
          },
          visitorFullName: {
            required: true,
          },
          relationship: {
            required: true,
          },
          contactPhoneNo: {
            required: true,
          },
          cancel: {
            disabled: true,
          },
          hocEndDate: {
            disabled: true,
          },
          hocEndTime: {
            disabled: true,
          },
        };

      case SCHEDULED_BOOKING:
        if (info.timeslotBookingStatusEnum === TELEVISIT_STATUS.COMPLETED) {
          return {
            date: {
              disabled: true,
            },
            time: {
              disabled: true,
            },
            contactPhoneNo: {
              disabled: true,
            },
            zoom: {
              disabled: true,
            },
            cancel: {
              disabled: true,
            },
            confirm: {
              disabled: true,
            },
            visitorFullName: {
              disabled: true,
            },
            relationship: {
              disabled: true,
            },
            hocStartDate: {
              disabled: true,
            },
            hocStartTime: {
              disabled: true,
            },
            durationTime: {
              disabled: true,
            },
            hocEndDate: {
              disabled: true,
            },
            hocEndTime: {
              disabled: true,
            },
          };
        }
        return {
          visitorFullName: {
            required: true,
            disabled: detail.bookingSource !== TELEVISIT_BOOKING_SOURCE.WP,
          },
          relationship: {
            required: true,
            disabled: detail.bookingSource !== TELEVISIT_BOOKING_SOURCE.WP,
          },
          contactPhoneNo: {
            required: true,
            disabled: detail.bookingSource !== TELEVISIT_BOOKING_SOURCE.WP,
          },
          date: {
            disabled: detail.hocFlag === 1,
          },
          time: {
            disabled: detail.hocFlag === 1,
          },
          hocStartDate: {
            disabled: false,
            required: true,
          },
          hocStartTime: {
            disabled: false,
            required: true,
          },
          hocEndDate: {
            disabled: true,
          },
          hocEndTime: {
            disabled: true,
          },
        };
      case VERIFYING_BOOKING:
        return {
          date: {
            disabled: true,
          },
          time: {
            disabled: true,
          },
          contactPhoneNo: {
            disabled: true,
          },
          zoom: {
            disabled: true,
          },
          cancel: {
            disabled: true,
          },
          confirm: {
            disabled: true,
          },
          visitorFullName: {
            disabled: true,
          },
          relationship: {
            disabled: true,
          },
          hocStartDate: {
            disabled: true,
          },
          hocStartTime: {
            disabled: true,
          },
          durationTime: {
            disabled: true,
          },
          hocEndDate: {
            disabled: true,
          },
          hocEndTime: {
            disabled: true,
          },
        };
      case INPROGRESS_BOOKING:
        return {
          date: {
            disabled: true,
          },
          time: {
            disabled: true,
          },
          contactPhoneNo: {
            disabled: true,
          },
          cancel: {
            disabled: true,
          },
          confirm: {
            disabled: true,
          },
          visitorFullName: {
            disabled: true,
          },
          relationship: {
            disabled: true,
          },
          hocStartDate: {
            disabled: true,
          },
          hocStartTime: {
            disabled: true,
          },
          durationTime: {
            disabled: true,
          },
          hocEndDate: {
            disabled: true,
          },
          hocEndTime: {
            disabled: true,
          },
        };
      default:
        return {};
    }
  }, [type, isOutDate, detail.bookingSource, detail.hocFlag, info.timeslotBookingStatusEnum]);

  const serviceSupportProps = useMemo(() => {
    if (type === UNAVAILABLE || type === AVAILABLE || type === URGENT_BOOK) {
      return {
        visible: false,
        disabled: false,
      };
    }
    if (isOutDate) {
      if (
        _.indexOf(
          [TELEVISIT_STATUS.INPROGRESS, TELEVISIT_STATUS.ROBOT_START_PROCESSING_BOOKING],
          data?.timeslotBookingStatusEnum
        ) !== -1
      ) {
        return {
          visible: true,
          disabled: false,
        };
      }

      return {
        visible: true,
        disabled: true,
      };
    }
    if (_.indexOf([3, 4, 8, 9], data?.timeslotBookingStatusEnum) !== -1) {
      return {
        visible: true,
        disabled: false,
      };
    }
    return {
      visible: true,
      disabled: true,
    };
  }, [type, isOutDate, data.timeslotBookingStatusEnum]);

  const getTimeslotlist = useCallback(async () => {
    try {
      const params =
        type === UNAVAILABLE || type === AVAILABLE || type === URGENT_BOOK
          ? {
              robotId: info.robotId,
            }
          : {
              bookId: info.bookId,
            };
      const { result, serviceHoursList, serviceDay } = await teleVisitAPI.getTimeslotLatestList(params);
      setList(result);
      setServiceHoursList(serviceHoursList);
      setServiceDay(serviceDay);
    } catch (error) {
      console.log(error);
    }
  }, [info.robotId, info.day, info.startTime, info.endTime, info.durationTime, type, info.bookId]);

  useEffect(() => {
    (async () => {
      await getTimeslotlist();
    })();
  }, [getTimeslotlist]);

  const getPatientList = useCallback(async () => {
    try {
      if (type === VERIFYING_BOOKING || type === SCHEDULED_BOOKING || type === CANCELED_BOOKING || type === INPROGRESS_BOOKING) {
        return;
      }
      const { result } = await teleVisitAPI.getPatient();

      setPatient(result);
    } catch (error) {
      console.log(error);
    }
  }, [type]);

  useEffect(() => {
    (async () => {
      await getPatientList();
    })();
  }, [getPatientList]);

  const getRelationship = useCallback(async () => {
    try {
      const { result } = await teleVisitAPI.getStaticDataList();

      const relationshipData = _.filter(result.staticData, (item) => item.dataKey === 'Relationship');

      const cancelTypeData = _.filter(result.staticData, (item) => item.dataType === 'CancellationReason');

      const langCode = _.filter(result.staticData, (item) => item.dataType === 'LANG_CODE');

      const hocSupportData = _.filter(result.staticData, (item) => item.dataType === 'HocSupport');

      const delayReasonData = _.filter(result.staticData, (item) => item.dataType === 'DelayMeetingReason');

      const serviceHourTimeslotData = _.filter(result.staticData, (item) => item.dataKey === 'ServiceHourTimeslot');
      const durationTimeData = _.filter(result.staticData, (item) => item.dataKey === 'ServiceHourDuartion');

      // booking status
      const timeslotBookingStatusData = _.filter(
        result.statusData,
        (item) =>
          item.dataKey === 'TimeslotBookingStatus' &&
          item.dataType === 'DropDown' &&
          item.dataValue !== '0' &&
          item.dataValue !== '1' &&
          item.dataValue !== '2'
      );
      const statusList = _.sortBy(
        _.map(timeslotBookingStatusData, (item) => ({
          text: getStatusText(item),
          value: item.dataValue,
          displaySeq: item.displaySeq,
        })),
        ['displaySeq']
      );

      let bufferTimeData = _.filter(result.staticData, (item) => item.dataKey === 'ServiceHourBufferTime');

      bufferTimeData.push({
        dataKey: 'ServiceHourBufferTime',
        dataType: 'DropDown',
        dataValue: '0',
        descCH: i18n.get('TELEVISIT_SETTING_POPUP_BUFFER_TIME_ZERO'),
        descEN: i18n.get('TELEVISIT_SETTING_POPUP_BUFFER_TIME_ZERO'),
        displaySeq: 0,
      });

      setSmsType(langCode);
      setRelationship(relationshipData);
      setCancelType(cancelTypeData);
      setHocSupport(hocSupportData);
      setDelayReason(delayReasonData);
      setServiceHourTimeslot(serviceHourTimeslotData);
      setDurationTime(durationTimeData);
      setBufferTime(bufferTimeData);
      setTimeslotBookingStatus(statusList);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await getRelationship();
    })();
  }, [getRelationship]);

  // Check if the time is included in the service time; true: not included; false:  included;
  const checkTimeIncluedServiceTime = useCallback((serviceHoursList, time, date, serviceIds) => {
    const dayList = _.find(serviceHoursList, (item) => {
      return item.date === date;
    });
    if (dayList === undefined) {
      return true;
    }
    let result = _.find(dayList?.serviceHours, (itemA) => {
      return (
        !serviceIds.includes(itemA.serviceHoursSettingId) &&
        moment(itemA?.startTime, 'HH:mm').isBefore(moment(time, 'HH:mm')) &&
        moment(itemA?.endTime, 'HH:mm').isAfter(moment(time, 'HH:mm'))
      );
    });
    return result === undefined;
  }, []);

  const checkTimeRangeIncluedServiceTime = useCallback((serviceHoursList, starTime, startDate, serviceIds, endTime) => {
    const dayList = _.find(serviceHoursList, (item) => {
      return item.date === startDate;
    });
    if (dayList === undefined) {
      return true;
    }
    let result = _.find(dayList?.serviceHours, (itemA) => {
      return (
        !serviceIds.includes(itemA.serviceHoursSettingId) &&
        moment(itemA?.startTime, 'HH:mm').isSameOrAfter(moment(starTime, 'HH:mm')) &&
        moment(itemA?.endTime, 'HH:mm').isSameOrBefore(moment(endTime, 'HH:mm'))
      );
    });
    return result === undefined;
  }, []);

  // true expired; false not expired
  const checkStartTimeExpired = useCallback((time, date) => {
    if (moment(date, 'x').isBefore(moment(), 'day')) {
      return true;
    }
    if (moment(date, 'x').isAfter(moment(), 'day')) {
      return false;
    }
    return moment(time, 'HH:mm').isSameOrBefore(moment());
  }, []);

  const getDataList = useCallback(() => {
    if (data.hocFlag === 1 || info.timeslotBookingStatusEnum === TELEVISIT_STATUS.URGENT_BOOK) {
      const adhocDateList = _.times(serviceDay, (index) => {
        const date = moment().startOf('day').add(index, 'day');
        return {
          text: date.format('yyyy-MM-DD'),
          value: Number(date.valueOf()),
        };
      });
      return adhocDateList;
    }
    let dateList = _.map(Object.keys(_.groupBy(list, 'day')), (item) => ({
      text: moment(item, 'x').format('yyyy-MM-DD'),
      value: Number(item),
    }));

    if (!_.some(dateList, ['value', Number(data.date)])) {
      dateList.push({
        text: moment(data.date, 'x').format('yyyy-MM-DD'),
        value: Number(data.date),
      });
    }

    return dateList;
  }, [info, list, serviceDay, data]);

  const getDesc = (language, item) => {
    return language === 'en-us' ? item.descEN : item.descCH;
  };

  const getTempTimesList = (list, data) => {
    let tempTimeList = _.map(
      list.filter((item) => {
        const day = item.isMainBooking === 1 ? 1 : 0;
        return (
          item.day === data.date &&
          (moment().isSame(moment(data.date), 'D')
            ? moment().isBefore(moment(item.endTime, 'hh:mm').add(day, 'day'))
            : true) &&
          item.timeslotBookingStatusEnum !== 10
        );
      }),
      (item) => ({
        ...item,
        text: `${item.startTime} - ${item.endTime}`,
        value: `${item.startTime} - ${item.endTime}`,
        hocFlag: item.hocFlag,
      })
    );

    if (!_.some(tempTimeList, ['value', data.time])) {
      tempTimeList.push({
        text: data.time,
        value: data.time,
        hocFlag: data.hocFlag,
      });
    }
    tempTimeList = tempTimeList.sort((itemA, itemB) =>
      moment(itemA?.text?.slice(0, 5), 'hh:mm').isBefore(moment(itemB?.text?.slice(0, 5), 'hh:mm')) ? -1 : 1
    );
    return tempTimeList;
  };

  const itemLists = useMemo(() => {
    const dateList = getDataList();
    const tempTimeList = getTempTimesList(list, data);

    const groupTimeList = _.groupBy(tempTimeList, 'value');

    const timeList = _.map(Object.keys(groupTimeList), (item) => ({
      text: item,
      value: item,
      hocFlag: groupTimeList[item][0].hocFlag,
    }));

    const startTimeList = _.sortBy(
      _.map(serviceHourTimeslot, (item) => ({
        text: getDesc(language, item),
        value: item.dataValue,
        displaySeq: item.displaySeq,
      })),
      ['displaySeq']
    ).filter((item) => {
      return (
        checkTimeIncluedServiceTime(serviceHoursList, item?.value, data.date, data.serviceHourSettingIds) &&
        !checkStartTimeExpired(item?.value, data.date)
      );
    });

    const endTimeList = _.sortBy(
      _.map(serviceHourTimeslot, (item) => ({
        text: getDesc(language, item),
        value: item.dataValue,
        displaySeq: item.displaySeq,
      })),
      ['displaySeq']
    );

    let patientList = _.map(patient, (item) => ({
      text: item.patientNameCH
        ? `${item.bedNo} - ${item.patientNameEN}, ${item.patientNameCH}`
        : `${item.bedNo} - ${item.patientNameEN}`,
      value: item.patientKey,
      info: item,
      sort: item.bedNo,
    }));
    patientList = _.sortBy(patientList, 'sort');

    const relationshipList = _.sortBy(
      _.map(relationship, (item) => ({
        text: getDesc(language, item),
        value: item.dataValue,
        displaySeq: item.displaySeq,
      })),
      ['displaySeq']
    );

    const cancelTypeList = _.sortBy(
      _.filter(cancelType, (item) =>
        _.some(Object.values(TELEVISIT_CANCEL_TYPE), (typeItem) => String(typeItem) === item.dataValue)
      ),
      ['displaySeq']
    ).map((item) => ({
      text: getDesc(language, item),
      value: item.dataValue,
    }));

    const cancelTypeRemark = _.map(cancelType, (item) => ({
      text: getDesc(language, item),
      value: item.dataValue,
    }));

    const smsTypeList = _.sortBy(
      _.map(smsType, (item) => ({
        text: getDesc(language, item),
        value: item.dataValue,
        displaySeq: item.displaySeq,
      })),
      ['displaySeq']
    );

    setCancelInfo({
      cancelReasonType: cancelTypeList[0]?.value,
      otherCancelReasonMsg: '',
    });

    let hocSupportList = _.sortBy(
      _.map(hocSupport, (item) => ({
        text: getDesc(language, item),
        value: item.dataValue,
        displaySeq: item.displaySeq,
      })),
      ['displaySeq']
    );

    if (!roleMap[authNameE.teleVisit_Service_Support_update_booking_status]) {
      hocSupportList = hocSupportList.filter((item) => item.value !== 'UpdateBookingStatus');
    }

    const delayReasonList = _.sortBy(
      _.map(delayReason, (item) => ({
        text: getDesc(language, item),
        value: item.dataValue,
        displaySeq: item.displaySeq,
      })),
      ['displaySeq']
    );

    setDelayInfo({
      delayTime: 5,
      delayReasonType: delayReasonList[0]?.value,
      otherDelayReasonMsg: '',
      errorMessage: '',
    });

    const durationList = _.sortBy(
      _.map(durationTime, (item) => ({
        text: getDesc(language, item),
        value: Number(item.dataValue),
        displaySeq: item.displaySeq,
      })),
      ['displaySeq']
    );
    const bufferTimeList = _.sortBy(
      _.map(bufferTime, (item) => ({
        text: getDesc(language, item),
        value: Number(item.dataValue),
        displaySeq: item.displaySeq,
      })),
      ['displaySeq']
    );

    if (type === URGENT_BOOK) {
      setData((oldData) => ({
        ...oldData,
        bufferTime: oldData.bufferTime ? oldData.bufferTime : bufferTimeList[0]?.value,
        durationTime: oldData.durationTime ? oldData.durationTime : durationList[0]?.value,
      }));
    }
    const serviceSupportUpdateBookingStatus = _.filter(
      timeslotBookingStatus,
      (item) => item.value === String(TELEVISIT_STATUS.COMPLETED) || item.value === String(TELEVISIT_STATUS.CANCEL)
    );

    return {
      dateList,
      timeList,
      relationshipList,
      patientList,
      cancelTypeList,
      smsTypeList,
      groupTimeList,
      cancelTypeRemark,
      hocSupportList,
      delayReasonList,
      durationList,
      startTimeList,
      endTimeList,
      bufferTimeList,
      serviceSupportUpdateBookingStatus,
    };
  }, [
    list,
    relationship,
    patient,
    data.date,
    i18n,
    language,
    cancelType,
    smsType,
    hocSupport,
    delayReason,
    durationTime,
    bufferTime,
    serviceHoursList,
    serviceHourTimeslot,
    serviceDay,
    timeslotBookingStatus,
  ]);

  const timeCheck = useCallback((value) => {
    if (value === '') {
      return true;
    } else if (value.length === 5 && value[2] === ':') {
      return moment(value, 'HH:mm').isValid();
    }
    return false;
  }, []);

  const computeHocDate = useCallback(
    (key, value) => {
      let startTime = data.startTime;
      let tempDurationTime = data.durationTime;
      let tempBufferTime = data.bufferTime;
      let currentDate = moment(data.date, 'x').valueOf();

      switch (key) {
        case 'date':
          currentDate = value;
          break;
        case 'startTime':
          startTime = value;
          break;
        case 'durationTime':
          tempDurationTime = value;
          break;
        case 'bufferTime':
          tempBufferTime = value;
          break;
        default:
          break;
      }

      let endTime = '';
      let endDay = currentDate;
      if (startTime !== '' && tempDurationTime !== '' && tempBufferTime !== '' && currentDate !== '') {
        // compute  End Date 和 End time
        let currentStartDateTimeStr = `${moment(currentDate, 'x').format('yyyy-MM-DD')} ${startTime}`;
        let endDate = moment(currentStartDateTimeStr, 'yyyy-MM-DD HH:mm').add(tempDurationTime, 'm');
        endTime = endDate.format('HH:mm');
        endDay = endDate.startOf('day').valueOf();
      }

      return {
        currentDate: currentDate,
        endTime: endTime,
        startTime: startTime,
        endDate: endDay,
        bufferTime: tempBufferTime,
        durationTime: tempDurationTime,
      };
    },
    [data]
  );

  const handelStartTime = (key, data, value) => {
    let startTime = data.startTime;
    if (key === 'startTime') {
      startTime = value;
    }

    if (!/^\\d+$/.test(startTime)) {
      startTime = startTime.replaceAll(/[^0-9:]/g, '');
    }

    if (data.startTime.length === 1 && startTime.length === 2) {
      startTime += ':';
    }
    if (startTime.length === 3 && startTime.indexOf(':') === -1) {
      startTime = `${startTime.slice(0, 2)}:${startTime.slice(2, 3)}`;
    }
    if (startTime.length > 5) startTime = startTime.slice(0, 5);
    return startTime;
  };

  const checkServiceHoursConflict = (newHocTimeDate) => {
    let currentStartDateTimeStr = `${moment(newHocTimeDate.currentDate, 'x').format('yyyy-MM-DD')} ${
      newHocTimeDate.startTime
    }`;

    let robotStartTime = moment(currentStartDateTimeStr, 'yyyy-MM-DD HH:mm').subtract(newHocTimeDate.bufferTime, 'm');
    let robotStartDate = moment(robotStartTime).startOf('day').valueOf();

    const robotStartTimeStr = robotStartTime.format('HH:mm');
    let errorMesg = '';
    if (checkStartTimeExpired(robotStartTimeStr, robotStartDate)) {
      if (moment(currentStartDateTimeStr, 'yyyy-MM-DD HH:mm').isSameOrAfter(moment())) {
        errorMesg = { bufferTime: i18n.t('TELEVISIT_ADHOC_INVALID_BUFFER_TIME') };
      } else {
        errorMesg = { startTime: i18n.t('SETTING_TELEVISIT_SERVICE_HOUR_INVALID_START_TIME') };
      }
      return errorMesg;
    }

    const endTimeStr = moment(newHocTimeDate.endTime, 'HH:mm').format('HH:mm');

    const startTimeCheck = checkTimeIncluedServiceTime(
      serviceHoursList,
      robotStartTimeStr,
      robotStartDate,
      data.serviceHourSettingIds
    );
    const endTimeCheck = checkTimeIncluedServiceTime(
      serviceHoursList,
      endTimeStr,
      newHocTimeDate.endDate,
      data.serviceHourSettingIds
    );
    if (!startTimeCheck || !endTimeCheck) {
      const serviceConflictCheck = checkTimeIncluedServiceTime(
        serviceHoursList,
        newHocTimeDate.startTime,
        robotStartDate,
        data.serviceHourSettingIds
      );
      if (newHocTimeDate.bufferTime === 0 || !serviceConflictCheck || !endTimeCheck) {
        errorMesg = { startTime: i18n.t('TELEVISIT_POPUP_ADHOC_TIMESLOT_SERVICEHOUR_CONFLICT') };
      } else {
        errorMesg = { bufferTime: i18n.t('TELEVISIT_POPUP_ADHOC_TIMESLOT_SERVICEHOUR_CONFLICT') };
      }
      return errorMesg;
    }

    if (
      robotStartDate === newHocTimeDate.endDate &&
      !checkTimeRangeIncluedServiceTime(
        serviceHoursList,
        robotStartTimeStr,
        robotStartDate,
        data.serviceHourSettingIds,
        endTimeStr
      )
    ) {
      const serviceConflictCheck = checkTimeIncluedServiceTime(
        serviceHoursList,
        newHocTimeDate.startTime,
        robotStartDate,
        data.serviceHourSettingIds,
        endTimeStr
      );
      if (!serviceConflictCheck) {
        errorMesg = { startTime: i18n.t('TELEVISIT_POPUP_ADHOC_TIMESLOT_SERVICEHOUR_CONFLICT') };
      } else {
        errorMesg = { bufferTime: i18n.t('TELEVISIT_POPUP_ADHOC_TIMESLOT_SERVICEHOUR_CONFLICT') };
      }
      return errorMesg;
    }
    return errorMesg;
  };

  const hocBookingTimeUpdateAndCheck = useCallback(
    (key, value) => {
      setInfoErrorMsg((oldData) => ({
        ...oldData,
        startTime: '',
        bufferTime: '',
      }));

      if (data.hocFlag !== 1 && info.timeslotBookingStatusEnum !== TELEVISIT_STATUS.URGENT_BOOK) {
        return true;
      }

      let startTime = handelStartTime(key, data, value);

      if (key === 'startTime') {
        value = startTime;
        setData((oldData) => ({
          ...oldData,
          startTime: value,
        }));
      }

      if (startTime === '') {
        setInfoErrorMsg((oldData) => ({
          ...oldData,
          startTime: i18n.t('TELEVISIT_ADVANCE_SEARCH_START_TIME_ERROR_MSG'),
        }));
        return false;
      }
      if (!timeCheck(startTime)) {
        // error message
        setInfoErrorMsg((oldData) => ({
          ...oldData,
          startTime: i18n.t('TELEVISIT_INVALID_DATE_FORMAT'),
        }));
        return false;
      }
      const newHocTimeDate = computeHocDate(key, value);
      setData((oldData) => ({
        ...oldData,
        date: newHocTimeDate.currentDate,
        endTime: newHocTimeDate.endTime,
        startTime: newHocTimeDate.startTime,
        endDate: newHocTimeDate.endDate,
        bufferTime: newHocTimeDate.bufferTime,
      }));

      if (!checkUpdate(detail, newHocTimeDate)) {
        return true;
      }

      let errorMessage = checkServiceHoursConflict(newHocTimeDate);
      if (errorMessage !== '') {
        setInfoErrorMsg((oldData) => ({
          ...oldData,
          ...errorMessage,
        }));
        return false;
      }
      return true;
    },
    [info, data, serviceHoursList]
  );

  const checkUpdate = (detail, newData) => {
    let isUpdate =
      newData.currentDate !== detail.timeslotDate ||
      newData.bufferTime !== detail.bufferTime ||
      newData.durationTime !== detail.durationTime ||
      newData.startTime !== detail.startTime;
    return isUpdate;
  };

  const getTargetValue = (type, value) => {
    return type === 'input' ? value.target.value : value;
  };

  const handleDateUpdate = (key, value, list) => {
    if (key === 'date') {
      const timeList = _.map(
        list.filter((item) => {
          return (
            item.day === value &&
            (moment().isSame(moment(value), 'D') ? moment().isBefore(moment(item.endTime, 'hh:mm')) : true)
          );
        }),
        (item) => ({
          text: `${item.startTime} - ${item.endTime}`,
          value: `${item.startTime} - ${item.endTime}`,
          hocFlag: item.hocFlag,
        })
      ).sort((itemA, itemB) =>
        moment(itemA?.text?.slice(0, 5), 'hh:mm').isBefore(moment(itemB?.text?.slice(0, 5), 'hh:mm')) ? -1 : 1
      );
      setData((oldData) => ({
        ...oldData,
        time: timeList[0]?.hocFlag !== 1 ? timeList[0]?.value : '',
      }));
    }
  };

  const updateData = useCallback(
    (key, type) => (value) => {
      handleDateUpdate(key, value, list);

      if (key === 'date' || key === 'startTime' || key === 'durationTime' || key === 'bufferTime') {
        hocBookingTimeUpdateAndCheck(key, getTargetValue(type, value));
      }
      if (key !== 'startTime') {
        setData((oldData) => {
          const newData = {
            ...oldData,
            [key]: getTargetValue(type, value),
          };
          if (_.some(Object.keys(infoErrorMsg))) {
            verify(key, newData);
          }
          return newData;
        });
      }
      if (key !== 'relationship' && key !== 'visitorFullName') {
        setUpdateFlag(true);
      }
    },
    [verify, list, data.date, data]
  );

  const handleOpen = useCallback(
    (key) => () => {
      setOpenCtrl((oldData) => {
        const keys = Object.keys(oldData);
        _.forEach(keys, (item) => {
          oldData[item] = item === key;
        });
        return { ...oldData };
      });
    },
    []
  );

  useEffect(() => {
    let patientData = _.find(itemLists.patientList, (item) => item.value === data.patient)?.info;

    if (patientData) {
      const value = patientData.patientCaseNumber ? `${patientData.patientCaseNumber}, ` : '';
      updateData('location')(
        [patientData.ipasHospitalCode, patientData.ipasWardLocation, patientData.bedNo]
          .filter((item) => item)
          .join(', ')
      );
      updateData('patientName')(
        [patientData.patientNameEN, patientData.patientNameCH].filter((item) => item).join(', ')
      );
      updateData('patientId')(`${value} ${[patientData.sex, patientData.age].filter((item) => item).join('/')}`);
    }
  }, [itemLists.patientList, data.patient]);

  const handleCancel = useCallback(async () => {
    try {
      switch (type) {
        case SCHEDULED_BOOKING:
          handleOpen('cancel')();
          break;
        case AVAILABLE:
          if (openCtrl.unavailable) {
            await teleVisitAPI.updateTimeslotStatus({
              day: info.day,
              endTime: info.endTime,
              robotId: info.robotId,
              serviceHourSettingExceptionId: info.serviceHoursExceptionId,
              serviceHoursSettingId: info.serviceHoursSettingId,
              startTime: info.startTime,
            });
            handleClose();
          } else {
            handleOpen('unavailable')();
          }
          break;
        case UNAVAILABLE:
          await teleVisitAPI.updateTimeslotStatus({
            day: info.day,
            endTime: info.endTime,
            robotId: info.robotId,
            serviceHourSettingExceptionId: info.serviceHoursExceptionId,
            serviceHoursSettingId: info.serviceHoursSettingId,
            startTime: info.startTime,
            timeslotUnavailableId: info.timeslotUnavailableId,
          });
          handleClose();
          break;
        default:
          break;
      }
    } catch (error) {
      console.log(error);
    }
  }, [type, handleClose, info, handleOpen, openCtrl]);

  const handleSubmit = useCallback(async () => {
    try {
      const selectTimes = itemLists.groupTimeList[data.time];

      switch (type) {
        case SCHEDULED_BOOKING: {
          if (data.hocFlag === 1) {
            let params = {
              ...detail,
              timeslotDate: data.date,
              startTime: data.startTime,
              endTime: data.endTime,
              contactPhoneNo: data.contactPhoneNo,
              langCode: data.langCode,
              robotId: info.robotId,
              serviceHoursSettingId: info.serviceHoursSettingId,
              durationTime: data.durationTime,
              bufferTime: data.bufferTime,
              visitorFullName: data.visitorFullName,
              relationship: data.relationship,
            };
            await teleVisitAPI.updateBooking(params);
            await showUpdateMessage(type, data, detail);
            return;
          }

          const selectTime = _.find(selectTimes, (item) => item.robotId === info.robotId) ?? selectTimes[0];
          let params = {
            ...detail,
            timeslotDate: data.date,
            startTime: data.time.slice(0, 5),
            endTime: data.time.slice(-5),
            contactPhoneNo: data.contactPhoneNo,
            langCode: data.langCode,
            robotId: selectTime.robotId,
            serviceHoursSettingId: selectTime.serviceHoursSettingId,
            visitorFullName: data.visitorFullName,
            relationship: data.relationship,
          };
          await teleVisitAPI.updateBooking(params);
          await showUpdateMessage(type, data, detail);
          return;
        }
        case AVAILABLE: {
          const selectTime = _.find(selectTimes, (item) => item.robotId === info.robotId) ?? selectTimes[0];
          let patientData = _.find(itemLists.patientList, (item) => item.value === data.patient)?.info;
          let params = {
            age: patientData.age,
            applicationTime: moment().format('x'),
            bedNo: patientData.bedNo,
            contactPhoneNo: data.contactPhoneNo,
            endTime: data.time.slice(-5),
            hospitalCode: patientData.ipasHospitalCode,
            patientCaseNumber: patientData.patientCaseNumber,
            patientDob: patientData.dob,
            patientKey: patientData.patientKey,
            patientNameCh: patientData.patientNameCH,
            patientNameEn: patientData.patientNameEN,
            relationship: data.relationship,
            robotId: selectTime.robotId,
            robotName: info.robotName,
            robotStatusEnum: info.robotStatusEnum,
            serviceHoursSettingId: info.serviceHoursSettingId,
            sex: patientData.sex,
            startTime: data.time.slice(0, 5),
            timeslotBookingStatusEnum: 3,
            timeslotDate: info.day,
            version: info.version,
            visitorFullName: data.visitorFullName,
            wardCode: patientData.ipasWardLocation,
            langCode: data.langCode,
          };
          await teleVisitAPI.reserveAvailableTimeslot(params);
          handleClose();
          return;
        }
        case UNAVAILABLE: {
          let patientData = _.find(itemLists.patientList, (item) => item.value === data.patient)?.info;
          let params = {
            bedNo: patientData.bedNo,
            contactPhoneNo: data.contactPhoneNo,
            dob: patientData.dob,
            hospitalCode: patientData.ipasHospitalCode,
            patientKey: patientData.patientKey,
            patientCaseNumber: patientData.patientCaseNumber,
            patientNameCh: patientData.patientNameCH,
            patientNameEn: patientData.patientNameEN,
            relationship: data.relationship,
            robotId: info.robotId,
            sex: patientData.sex,
            timeslotUnavailableId: info.timeslotUnavailableId,
            visitorFullName: data.visitorFullName,
            version: info.version,
            wardCode: patientData.ipasWardLocation,
            langCode: data.langCode,
          };
          await teleVisitAPI.reserveUnavailableTimeslot(params);
          handleClose();
          return;
        }

        case URGENT_BOOK: {
          let patientData = _.find(itemLists.patientList, (item) => item.value === data.patient)?.info;
          let params = {
            timeslotBookingDetailVO: {
              age: patientData.age,
              applicationTime: moment().format('x'),
              bedNo: patientData.bedNo,
              contactPhoneNo: data.contactPhoneNo,
              endTime: data.endTime,
              hospitalCode: patientData.ipasHospitalCode,
              patientCaseNumber: patientData.patientCaseNumber,
              patientDob: patientData.dob,
              patientKey: patientData.patientKey,
              patientNameCh: patientData.patientNameCH,
              patientNameEn: patientData.patientNameEN,
              relationship: data.relationship,
              robotId: info.robotId,
              robotName: info.robotName,
              robotStatusEnum: info.robotStatusEnum,
              serviceHoursSettingId: info.serviceHoursSettingId,
              sex: patientData.sex,
              startTime: data.startTime,
              timeslotBookingStatusEnum: 3,
              timeslotDate: data.date,
              /* timeslotEndDate: data.endDate, */
              version: info.version,
              visitorFullName: data.visitorFullName,
              wardCode: patientData.ipasWardLocation,
              langCode: data.langCode,
              durationTime: data.durationTime,
              bufferTime: data.bufferTime,
            },
          };
          await teleVisitAPI.addAdHocServiceHrAndReserveAvailableTimeslot(params);
          handleClose();
          return;
        }

        default:
          return;
      }
    } catch (error) {
      console.log(error);
    }
  }, [type, data, itemLists.patientList, handleClose, info, detail, itemLists.groupTimeList]);

  const checkIsUpdate = useCallback((updateFlag, data, detail) => {
    let isUpdate = updateFlag;
    if (data.bookingId) {
      if (data.hocFlag !== 1) {
        isUpdate =
          data.date !== detail.timeslotDate ||
          data.time !== `${detail.startTime} - ${detail.endTime}` ||
          data.contactPhoneNo !== detail.contactPhoneNo;
      } else {
        isUpdate =
          data.date !== detail.timeslotDate ||
          data.bufferTime !== detail.bufferTime ||
          data.durationTime !== detail.durationTime ||
          data.startTime !== detail.startTime ||
          data.contactPhoneNo !== detail.contactPhoneNo;
      }
    }

    return isUpdate;
  }, []);

  const checkIsOnlyUpdateBufferTime = useCallback((updateFlag, data, detail) => {
    let isUpdate = updateFlag;
    if (data.bookingId) {
      if (data.hocFlag !== 1) {
        isUpdate = false;
      } else {
        isUpdate =
          data.date === detail.timeslotDate &&
          data.bufferTime !== detail.bufferTime &&
          data.durationTime === detail.durationTime &&
          data.startTime === detail.startTime &&
          data.contactPhoneNo === detail.contactPhoneNo;
      }
    }

    return isUpdate;
  }, []);

  const showUpdateMessage = useCallback(async (type, data, detail) => {
    let isUpdate = checkIsUpdate(true, data, detail);
    const isOnlyUpdateBufferTime = checkIsOnlyUpdateBufferTime(updateFlag, data, detail);
    if (type === SCHEDULED_BOOKING && (!isUpdate || isOnlyUpdateBufferTime)) {
      await getDetail();
      handleOpen('timeslot')();
      alertMsg(i18n.t('TELEVISIT_POPUP_UPDATE_BOOKING_SEND_MESSAGE'), 'updateBooking', 'success');
    } else {
      handleClose();
    }
  }, []);

  const handleConfirm = useCallback(() => {
    let flag = true;

    _.forEach(
      Object.keys(infoErrorMsg).filter((item) => (type === SCHEDULED_BOOKING ? item !== 'patient' : true)),
      (item) => {
        if (!verify(item, data)) {
          flag = false;
        }
      }
    );

    if (type === URGENT_BOOK || data.hocFlag === 1) {
      flag = hocBookingTimeUpdateAndCheck() && flag;
      handelAdHocConfirm(flag);
      return;
    }

    if (flag) {
      let isUpdate = checkIsUpdate(updateFlag, data, detail);
      if (type !== AVAILABLE && isUpdate && type !== URGENT_BOOK) {
        handleOpen(type === SCHEDULED_BOOKING ? 'update' : 'resume')();
      } else {
        (async () => {
          await handleSubmit();
        })();
      }
    }
  }, [type, handleOpen, verify, data, infoErrorMsg, handleSubmit, updateFlag]);

  const checkAdHocUpdate = (flag, isUpdate, type) => {
    return flag && isUpdate && type === SCHEDULED_BOOKING;
  };
  const checkAdHocrReserve = (flag, type) => {
    return flag && type === URGENT_BOOK;
  };
  const validaUpdateAdhocBooking = (isOnlyUpdateBufferTime, type) => {
    validateTimeslotBooking().then((result) => {
      if (result) {
        if (isOnlyUpdateBufferTime) {
          (async () => {
            await handleSubmit();
          })();
        } else {
          handleOpen(type === SCHEDULED_BOOKING ? 'update' : 'resume')();
        }
      }
    });
  };
  const validateReserveAdhocBooking = () => {
    validateTimeslotBooking().then((result) => {
      if (result) {
        (async () => {
          await handleSubmit();
        })();
      }
    });
  };
  const handelAdHocConfirm = (flag) => {
    let isUpdate = checkIsUpdate(updateFlag, data, detail);
    const isOnlyUpdateBufferTime = checkIsOnlyUpdateBufferTime(updateFlag, data, detail);
    if (checkAdHocUpdate(flag, isUpdate, type)) {
      // for ad hoc bookings update, call api validate
      validaUpdateAdhocBooking(isOnlyUpdateBufferTime, type);
      return;
    }

    if (checkAdHocrReserve(flag, type)) {
      // for ad hoc bookings reserve, call api validate
      validateReserveAdhocBooking();
      return;
    }

    if (flag) {
      (async () => {
        await handleSubmit();
      })();
    }
  };

  const validateTimeslotBooking = useCallback(async () => {
    try {
      if (data.hocFlag === 1) {
        let params = {
          ...detail,
          timeslotDate: data.date,
          startTime: data.startTime,
          endTime: data.endTime,
          robotId: info.robotId,
          serviceHoursSettingId: 0,
          durationTime: data.durationTime,
          bufferTime: data.bufferTime,
          hocFlag: data.hocFlag,
        };
        if (type === URGENT_BOOK) {
          let patientData = _.find(itemLists.patientList, (item) => item.value === data.patient)?.info;
          params = {
            age: patientData.age,
            applicationTime: moment().format('x'),
            bedNo: patientData.bedNo,
            contactPhoneNo: data.contactPhoneNo,
            endTime: data.endTime,
            hospitalCode: patientData.ipasHospitalCode,
            patientCaseNumber: patientData.patientCaseNumber,
            patientDob: patientData.dob,
            patientKey: patientData.patientKey,
            patientNameCh: patientData.patientNameCH,
            patientNameEn: patientData.patientNameEN,
            relationship: data.relationship,
            robotId: info.robotId,
            robotName: info.robotName,
            robotStatusEnum: info.robotStatusEnum,
            serviceHoursSettingId: info.serviceHoursSettingId,
            sex: patientData.sex,
            startTime: data.startTime,
            timeslotBookingStatusEnum: 3,
            timeslotDate: data.date,
            version: info.version,
            visitorFullName: data.visitorFullName,
            wardCode: patientData.ipasWardLocation,
            langCode: data.langCode,
            durationTime: data.durationTime,
            bufferTime: data.bufferTime,
            hocFlag: 1,
          };
        }
        let resultBol = true;

        let result = await teleVisitAPI.validateTimeslotBooking(params);

        if (result.result.resultCode !== '0') {
          resultBol = false;
        }
        if (result.result.resultCode === '5136') {
          setInfoErrorMsg((oldData) => ({
            ...oldData,
            bufferTime: i18n.t('TELEVISIT_POPUP_ADHOC_TIMESLOT_ADHOC_CONFLICT'),
          }));
        }
        if (result.result.resultCode === '5139') {
          setInfoErrorMsg((oldData) => ({
            ...oldData,
            startTime: i18n.t('TELEVISIT_POPUP_ADHOC_TIMESLOT_ADHOC_CONFLICT'),
          }));
        }
        if (result.result.resultCode === '5137') {
          setInfoErrorMsg((oldData) => ({
            ...oldData,
            bufferTime: i18n.t('TELEVISIT_POPUP_ADHOC_TIMESLOT_SERVICEHOUR_CONFLICT'),
          }));
        }
        if (result.result.resultCode === '5143') {
          setInfoErrorMsg((oldData) => ({
            ...oldData,
            startTime: i18n.t('TELEVISIT_POPUP_ADHOC_TIMESLOT_SERVICEHOUR_CONFLICT'),
          }));
        }

        return resultBol;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  }, [detail, data, info]);

  const resendSms = useCallback(async () => {
    try {
      await teleVisitAPI.resendSms({
        ...detail,
        timeslotDate: data.date,
        startTime: data.time.slice(0, 5),
        endTime: data.time.slice(-5),
        contactPhoneNo: data.contactPhoneNo,
      });
      alertMsg('Resend Zoom Link Success!', 'resendSms', 'success');
    } catch (error) {
      console.log(error);
    }
  }, [detail, data.date, data.time, data.contactPhoneNo]);

  const handerHocSupport = useCallback(
    (value) => {
      switch (value) {
        case 'DelaySMS':
          setDelayInfo({
            delayTime: 5,
            delayReasonType: itemLists.delayReasonList[0]?.value,
            otherDelayReasonMsg: '',
            errorMessage: '',
          });
          handleOpen('delaySMS')();
          break;
        case 'ManualMeeting':
          handleOpen('manualMeeting')();
          break;
        case 'UpdateBookingStatus':
          setServiceSupportUpdateBookingStatusInfo({
            bookingId: info.bookId,
            status: '',
            cancelReasonType: TELEVISIT_CANCEL_TYPE.OTHER,
            otherCancelReasonMsg: '',
            lang: language,
          });
          handleOpen('ServiceSupportUpdateBookingStatus')();
          break;
        default:
          break;
      }
    },
    [handleOpen, info.bookId]
  );

  const inputDelayReason = useCallback((event) => {
    setDelayInfo((oldData) => ({
      ...oldData,
      otherDelayReasonMsg: event.target.value,
    }));
  }, []);
  const delayReasonSelect = useCallback((type) => {
    setDelayInfo((oldData) => ({
      ...oldData,
      delayReasonType: type,
      otherDelayReasonMsg: '',
    }));
  }, []);
  const inputDelayTime = useCallback(
    (event) => {
      let value = event.target.value;
      let errorMessage = validNumber(value) ? '' : i18n.get('TELEVISIT_POPUP_INVALID_NUMBER_FORMAT');

      if (errorMessage === '' && value > detail.durationTime) {
        errorMessage = i18n.t('TELEVISIT_POPUP_INVALID_NUMBER_MAX', {
          value: detail.durationTime,
        });
      }
      console.log(detail.durationTime);
      setDelayInfo((oldData) => ({
        ...oldData,
        delayTime: value,
        errorMessage: errorMessage,
      }));
    },
    [delayInfo]
  );
  const validNumber = useCallback((value) => {
    return /^([1-9]\d*)$/.test(value);
  }, []);
  const delayBooking = useCallback(async () => {
    try {
      await teleVisitAPI.sendDelaySms({
        bookId: info.bookId,
        version: info.version,
        delayOtherReasonMsg: delayInfo.otherDelayReasonMsg,
        delayTime: delayInfo.delayTime,
        delayReasonType: delayInfo.delayReasonType,
      });
      alertMsg(i18n.t('TELEVISIT_POPUP_DELAY_BOOKING_SEND_MESSAGE'), 'delaySms', 'success');
      handleOpen('timeslot')();
    } catch (error) {
      console.log(error);
    }
  }, [delayInfo, info.bookId, info.version]);

  const startMettingManually = useCallback(async () => {
    try {
      const params = {
        bookId: info.bookId,
        wardId: info.wardId,
      };
      const { result } = await teleVisitAPI.startMeetingManually(params);
      handleClose();
      // 跳转url
      let newHostLink = result.hostLink;
      if (!_.includes(result.hostLink, 'zak=')) {
        newHostLink = _.replace(result.joinLink, '/j/', '/s/');
        newHostLink = _.replace(newHostLink, /(pwd=)[^&]*/, `zak=${result.zak}`);
      } else {
        newHostLink = _.replace(result.hostLink, /(zak=)[^&]*/, `zak=${result.zak}`);
      }
      window.open(newHostLink);
    } catch (error) {
      console.log(error);
    }
  }, [info.bookId, info.version]);

  const cancelBooking = useCallback(async () => {
    try {
      await teleVisitAPI.cancelBooking({
        bookId: info.bookId,
        version: info.version,
        ...cancelInfo,
        cancelReasonType: String(cancelInfo.cancelReasonType),
      });
      handleClose();
    } catch (error) {
      console.log(error);
    }
  }, [cancelInfo, info.bookId, info.version]);

  const cancelSelect = useCallback((type) => {
    setCancelInfo((oldData) => ({
      ...oldData,
      cancelReasonType: type,
    }));
  }, []);

  const inputCancelReason = useCallback((event) => {
    setCancelInfo((oldData) => ({
      ...oldData,
      otherCancelReasonMsg: event.target.value.trim(),
    }));
  }, []);

  const handleLang = useCallback(
    (type) => () => {
      setData((oldData) => ({
        ...oldData,
        langCode: itemLists.smsTypeList[type === 'EN' ? 0 : 1]?.value,
      }));
    },
    [itemLists.smsTypeList]
  );

  const patientFilterOptions = useCallback((options, state) => {
    if (state.inputValue === '') {
      return options;
    }
    const regex = /[\s,]+/g;

    const inputValue = state.inputValue.toLocaleLowerCase().replace(regex, '');

    return _.filter(options, (item) => item.text.toLocaleLowerCase().replace(regex, '').search(inputValue) !== -1);
  }, []);

  const serviceSupportUpdateBookingStatusSubmit = useCallback(async () => {
    try {
      await teleVisitAPI.serviceSupportUpdateBookingStatus({
        ...serviceSupportUpdateBookingStatusInfo,
        version: info.version,
      });
      await getDetail();
      handleOpen('timeslot')();
      alertMsg(
        i18n.t('TELEVISIT_POPUP_SERVICE_SUPPORT_UPDATE_BOOKING_STATUS_SEND_MESSAGE'),
        'updateBookingStatus',
        'success'
      );
    } catch (error) {
      console.log(error);
    }
  }, [serviceSupportUpdateBookingStatusInfo, info.bookId, info.version]);

  const serviceSupportUpdateBookingStatusHandleStatusSelect = useCallback((status) => {
    setServiceSupportUpdateBookingStatusInfo((oldData) => ({
      ...oldData,
      status: status,
    }));
  }, []);

  const serviceSupportUpdateBookingStatusHandleInputCancelReason = useCallback((event) => {
    setServiceSupportUpdateBookingStatusInfo((oldData) => ({
      ...oldData,
      otherCancelReasonMsg: event.target.value.trim(),
    }));
  }, []);

  return {
    moduleDisplay,
    dialogProps,
    visitField,
    data,
    updateData,
    itemLists,
    openCtrl,
    handleOpen,
    handleConfirm,
    handleCancel,
    handleSubmit,
    infoErrorMsg,
    resendSms,
    isOutDate,
    cancelBooking,
    cancelSelect,
    inputCancelReason,
    cancelInfo,
    handleLang,
    currentlyEffective,
    patientFilterOptions,
    handerHocSupport,
    delayInfo,
    inputDelayReason,
    delayReasonSelect,
    inputDelayTime,
    delayBooking,
    startMettingManually,
    detail,
    serviceSupportProps,
    serviceSupportUpdateBookingStatusInfo,
    serviceSupportUpdateBookingStatusSubmit,
    serviceSupportUpdateBookingStatusHandleStatusSelect,
    serviceSupportUpdateBookingStatusHandleInputCancelReason,
  };
}
